// services/PayablePdf.service.ts

import { payablePdfApi } from "../../api";

const PayablePdfService = {
    /**
     * 📄 Descarga el estado de cuenta PDF
     * de una cuenta por pagar.
     *
     * GET /api/pdf/Payables/{id}
     */
    download: async (
        id: number
    ): Promise<{
        blob: Blob;
        fileName: string | null;
    }> => {
        const response =
            await payablePdfApi.fetchBlob(`/${id}`);

        return {
            blob: response.data,
            fileName:
                response.fileName ||
                `estado_cuenta_${id}.pdf`,
        };
    },
};

export default PayablePdfService;